import { SET_SHARD, SET_WINDOW } from './types';

export const setShard = (shard) => {
  return {
    type: SET_SHARD,
    shard
  }
};

export const setWindow = (timeWindow) => {
  return {
    type: SET_WINDOW,
    timeWindow
  }
}



// WEBPACK FOOTER //
// ./src/actions/config.js